import trim from 'lodash/trim';
import leftPad from 'lodash/padStart';



const MONTHS = [
  __('sm@_jan'), __('sm@_feb'), __('sm@_mar'), __('sm@_apr'),
  __('sm@_may'), __('sm@_jun'), __('sm@_jul'), __('sm@_aug'),
  __('sm@_sep'), __('sm@_oct'), __('sm@_nov'), __('sm@_dec')
];

/**
 * @param {String} dateStr
 * @param {String[]} format
 * @returns {String} formatted number with KB/MB/etc
 * */
export const formatDate = (dateStr, format = [ 'dd', ' ', 'mmm', ' ', 'yyyy' ]) => {
  const date = new Date(trim(dateStr));

  return format.map((str) => {
    if (str === 'yyyy') {
      return date.getFullYear();
    }

    if (str === 'dd') {
      return leftPad(date.getDate(), 2, '0');
    }

    if (str === 'mm') {
      return leftPad(date.getMonth() + 1, 2, '0');
    }

    if (str === 'mmm') {
      return MONTHS[date.getMonth()];
    }

    return str;
  }).join('');
};



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/utils/formatDate.js